import DataStructure, { sanitize } from "./DataStructure.js";
import { deepFreeze } from "../util/misc.js";

export const PHONE_FIELDS = { country: 1, number: "", ext: "", type: "" };
deepFreeze(PHONE_FIELDS);

export const PHONE_TYPES = {
  cell: { label: "Cell", icon: "cellphone" },
  fax: { label: "Fax", icon: "fax" },
  home: { label: "Home", icon: "home" },
  office: { label: "Office", icon: "office" },
};
deepFreeze(PHONE_TYPES);

export default class Phone extends DataStructure {
  constructor(data = {}) {
    data = sanitize(data, PHONE_FIELDS);
    super(data);
  }

  // Editing

  get isValid() {
    return Boolean(this.data.number && this.data.number.length === 10);
  }

  // Formatting

  get type() {
    return this.data.type
      ? PHONE_TYPES[this.data.type] || {
          label: this.data.type,
          icon: "",
        }
      : null;
  }

  get link() {
    if (!this.isValid) {
      return "";
    }

    return (
      "tel:" +
      "+" +
      this.country +
      this.number +
      (this.ext ? ";" + this.ext : "")
    );
  }

  get vcard() {
    return (
      "+" + this.country + this.number + (this.ext ? ";ext=" + this.ext : "")
    );
  }

  toString() {
    if (!this.isValid) {
      return "";
    }

    return (
      (this.country ? `+${this.country} ` : "") +
      `(${this.number.slice(0, 3)}) ` +
      `${this.number.slice(3, 6)} - ${this.number.slice(6)}` +
      (this.ext ? " ext." + this.ext : "")
    );
  }
}
